import styled, { css } from 'styled-components'
import { themeColor } from 'LibNeo/theme'
import { Heading } from 'LibNeo/components/Basic/Heading'
import { Collapse } from 'antd'
import { IconComponent } from 'LibNeo/components/Basic/Icon'

export const TitleWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`

export const Description = styled.span`
	margin-top: 4px;
	display: block;
	color: ${themeColor('gray', 8)};
	max-width: 600px;
	font-size: 12px;
	line-height: 20px;
	cursor: default;
`

export const ToggleIcon = styled(IconComponent)<{ right?: boolean }>`
	transition: transform 0.3s;
	${({ right }) =>
		right &&
		css`
			margin-left: 16px;
		`}
	svg {
		fill: ${themeColor('gray', 8)};
	}
`
export const AccordionCollapse = styled(Collapse)<{ noExpanding?: boolean }>`
	background-color: initial;
	border: none;
	.ant-collapse-item.ant-collapse-no-arrow {
		border-bottom: none;

		.ant-collapse-header {
			padding: 0;
			${({ noExpanding }) =>
				noExpanding
					? css`
							cursor: default;
					  `
					: css`
							&:hover {
								${Heading} {
									color: ${themeColor('emerald', 5)};
								}

								${ToggleIcon} {
									svg {
										fill: ${themeColor('emerald', 5)};
									}
								}
							}
					  `}

			.ant-collapse-arrow {
				transition: transform 0.3s;
			}
		}

		.ant-collapse-content {
			background-color: initial;
			border: none;
			overflow: initial;

			.ant-collapse-content-box {
				padding: 0;
			}
		}
	}

	.ant-collapse-item-active > .ant-collapse-header {
		${ToggleIcon} {
			transform: rotate(90deg);
		}
	}
`
